import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  confirmLabel: string;
  message: React.ReactNode;
  conciergeRepSummary: string | null;
  /** Shown when upgrading an existing Société member. */
  upgradeReason?: string;
}

export default function ConfirmInfiniteEnrolmentDialog({
  open,
  onClose,
  onConfirm,
  isSubmitting,
  confirmLabel,
  message,
  conciergeRepSummary,
  upgradeReason,
}: Props) {
  return (
    <Dialog open={open} onClose={isSubmitting ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography variant="body2">{message}</Typography>
          {conciergeRepSummary && (
            <Typography variant="body2" color="text.secondary">
              Concierge representative: <strong>{conciergeRepSummary}</strong>
            </Typography>
          )}
          {upgradeReason && (
            <Typography variant="body2" color="text.secondary">
              Reason: {upgradeReason}
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary">
            This action cannot be undone from this screen.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="text" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? 'Processing…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
